export function getStackFrameLocations(from = 2, error = new Error()) {
    return error.stack
        .split("\n")
        .slice(from)
        .map((line) => line.trim().replace(/^at\s+/, ""))
}

globalThis.getStackFrameLocations = getStackFrameLocations
